/* eslint-disable */
import { CommonGet, CommonPost } from '../../../helpers/HttpClient';


export default {
    GetAllGroupsForDropDown,
    GetAllFactoriesByGroupID,
    GetFarmerDetailsByFactoryIDRouteID,
    GetVCCFactoriesByGroupID,
    GetDirectSupplierDetails,
    GetRejectGRNDetailReportData
};

async function GetAllGroupsForDropDown() {
    const response = await CommonGet('/api/FarmerwiseAvailability/GetAllGroupsForFarmerAvailabilityScreen', null);
    return response.data;
}

async function GetAllFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/FarmerwiseAvailability/GetFactoriesByGroupIDForFarmerAvailabilityScreen', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetVCCFactoriesByGroupID(groupID) {
    const response = await CommonGet('/api/Factory/GetVCCFactoriesByGroupID', 'groupID=' + parseInt(groupID));
    return response.data;
}

async function GetRejectGRNDetailReportData(model) {
    const response = await CommonPost('/api/RejectGRNDetailReport/GetRejectGRNDetailReportData', null, model);
    return response.data;
}

async function GetFarmerDetailsByFactoryIDRouteID(factoryID) {
    const response = await CommonGet('/api/Farmer/GetFarmerDetailsByFactoryIDRouteID', 'factoryID=' + parseInt(factoryID) + '&routeID=' + parseInt(0));
    return response.data;
}

async function GetDirectSupplierDetails(operationEntityID) {
    const response = await CommonGet('/api/SpecialOrder/GetDirectSupplierDetails', 'operationEntityID=' + parseInt(operationEntityID));
    return response.data;
}






